export const DISRUPTION_PROTECTION_TITLE =
  "Flight disruption assistance (formerly known as Rapid Rebooking)";

export const DISRUPTION_PROTECTION_SUBTITLE = "Terms and Conditions";
